import React from 'react'
import { fragDoc } from '../../utils/fragments'
import { mapPolicy, mapMetaData } from '../../utils/mapper'
import MetaData from '../../components/metadata'
import PolicyContent from '../../components/policy'

const Policy = props => {
  const metadata = mapMetaData(props.data.doc)
  const policy = mapPolicy(props.data.doc)


  return (
    <PolicyContent policy={policy} metadata={metadata} policies={props.data.policies.edges}/>
  )
}

export default Policy

export const query = graphql`
  query docQuery($id: String!) {
    doc: prismicCtDoc(id: { eq: $id }) {
        ...doc


    }
    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {

              text
            }


          }
      }
      }
      }

  }
`



// WEBPACK FOOTER //
// ./src/templates/policies/policy.js